import { render, staticRenderFns } from "./iphoneContent.vue?vue&type=template&id=3c5fc48c&scoped=true"
import script from "./iphoneContent.vue?vue&type=script&lang=js"
export * from "./iphoneContent.vue?vue&type=script&lang=js"
import style0 from "./iphoneContent.vue?vue&type=style&index=0&id=3c5fc48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5fc48c",
  null
  
)

export default component.exports